import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, className = "", y = 28 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHead({ chapter, title, copy, dark = false, testid }) {
  return (
    <div className="max-w-3xl" data-testid={testid}>
      <Reveal>
        <p
          className={`flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] ${
            dark ? "text-amber" : "text-amber"
          }`}
        >
          <span className="inline-block h-px w-8 bg-amber" aria-hidden="true" />
          {chapter}
        </p>
      </Reveal>
      <Reveal delay={0.08}>
        <h2
          className={`mt-5 font-serif text-3xl font-light leading-[1.12] tracking-tight sm:text-4xl md:text-5xl ${
            dark ? "text-paper" : "text-ink"
          }`}
        >
          {title}
        </h2>
      </Reveal>
      {copy && (
        <Reveal delay={0.16}>
          <p
            className={`mt-6 text-base leading-relaxed sm:text-lg ${
              dark ? "text-paper/70" : "text-body"
            }`}
          >
            {copy}
          </p>
        </Reveal>
      )}
    </div>
  );
}
